import { IState } from '../../../../store';
import { getOfferType, isCommercial } from '../../../../utils/offer_type';
import { commercialPriceSelector, residentialPriceSelector } from '../../../../selectors/price';

export const priceSelector = (state: IState) => {
  const {
    offerData: { offer },
    knAuctionCompanies,
  } = state;
  const offerType = getOfferType(offer);
  const isPriceAuction = offer.publishedUserId && knAuctionCompanies.includes(offer.publishedUserId);

  if (isCommercial(offerType)) {
    if (isPriceAuction) {
      return 'Электронные торги';
    }

    return commercialPriceSelector(state);
  }

  return residentialPriceSelector(state);
};
